
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as pricingq7hLQznf5sDmVmp1DnapVh77taqjuEWxS1X0_40g810Meta } from "/opt/buildhome/repo/pages/pricing.vue?macro=true";
import { default as featuresudNRb9TI2duc5NhpBRGmDqzF5pgqH_PQ0wvYrrcF0poMeta } from "/opt/buildhome/repo/pages/features.vue?macro=true";
import { default as adminDRB2CsvwR_nqs6bk3imqGWeVCP26ENkVEZm2_C2YybMMeta } from "/opt/buildhome/repo/pages/app/admin.vue?macro=true";
import { default as indexv37UAAEeM5fxWwo8N4j4Nil_RtdTUwSP54YHqm6Px3sMeta } from "/opt/buildhome/repo/pages/app/index.vue?macro=true";
import { default as profile2lFVpRLmQSmEtkLJx3tKv0i7rSfoT9gaHE_sijlQghsMeta } from "/opt/buildhome/repo/pages/app/profile.vue?macro=true";
import { default as index_45Ep789DWSoNzd7nSXOnBeAD8JOOiF0hr_uL1Al_45Z24AMeta } from "/opt/buildhome/repo/pages/resources/index.vue?macro=true";
import { default as indexCAVsYSJNcQpXpPjlDnMHX0tVdxscwv4Wjr6YO_45ZrXSAMeta } from "/opt/buildhome/repo/pages/app/projects/index.vue?macro=true";
import { default as _91name_93EmS8I4m9mIAupI4iT5yCIhgt6iuzIwMINdO_K51LgcMMeta } from "/opt/buildhome/repo/pages/resources/docs/[name].vue?macro=true";
import { default as alt_45textbOD9VtikXIj_6_45rHdOUUkK41j454POi7uqA_45CdzdoocMeta } from "/opt/buildhome/repo/pages/app/projects/[id]/editor/alt-text.vue?macro=true";
import { default as component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta } from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo } from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "features",
    path: "/features",
    component: () => import("/opt/buildhome/repo/pages/features.vue")
  },
  {
    name: "app-admin",
    path: "/app/admin",
    meta: adminDRB2CsvwR_nqs6bk3imqGWeVCP26ENkVEZm2_C2YybMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/app/admin.vue")
  },
  {
    name: "app",
    path: "/app",
    meta: indexv37UAAEeM5fxWwo8N4j4Nil_RtdTUwSP54YHqm6Px3sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/app/index.vue")
  },
  {
    name: "app-profile",
    path: "/app/profile",
    component: () => import("/opt/buildhome/repo/pages/app/profile.vue")
  },
  {
    name: "resources",
    path: "/resources",
    meta: index_45Ep789DWSoNzd7nSXOnBeAD8JOOiF0hr_uL1Al_45Z24AMeta || {},
    component: () => import("/opt/buildhome/repo/pages/resources/index.vue")
  },
  {
    name: "app-projects",
    path: "/app/projects",
    component: () => import("/opt/buildhome/repo/pages/app/projects/index.vue")
  },
  {
    name: "resources-docs-name",
    path: "/resources/docs/:name()",
    component: () => import("/opt/buildhome/repo/pages/resources/docs/[name].vue")
  },
  {
    name: "app-projects-id-editor-alt-text",
    path: "/app/projects/:id()/editor/alt-text",
    component: () => import("/opt/buildhome/repo/pages/app/projects/[id]/editor/alt-text.vue")
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/auth/login",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/auth/logout",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  }
]